import { cloneElement } from 'react';
import { Route } from '../types';
import { useRouter } from '../use-router';
import { ClickableJsx } from './types';
interface RouterLinkProps<T> {
  linkComponent: ClickableJsx;
  route: Route;
  state?: T;
}
export default function RouterLink<T extends Record<string, unknown> & unknown>({
  linkComponent,
  route,
  state,
}: RouterLinkProps<T>) {
  const { navigate } = useRouter();
  const handleClick = () => {
    navigate(route, state);
  };
  return cloneElement(linkComponent, { onClick: handleClick });
}
